import { MenuContentItem } from '@frontend/vanilla/core';

export interface CompetitionRoute {
    base?: string;
    context?: string;
    subContext?: string;
    sport?: number;
    sportName?: string;
    region?: number;
    regionName?: string;
    league?: number | number[];
    leagueName?: string;
    conference?: number;
    conferenceName?: string;
    virtualCompetitionGroup?: number;
    virtualCompetitionGroupName?: string;
    isVirtual?: boolean;
    tournament?: string;
    marketTemplate?: number;
    marketCategory?: number;
    marketOffer?: string;
    dynamicOfferCategory?: string;
    outrightCategory?: string;
    specialCategory?: string;
    coupon?: number;
    couponName?: string;
}
export enum CategoryType {
    OutrightCategory = 'outrightCategory',
    SpecialCategory = 'specialCategory',
}

export interface TopMenuContentItem extends MenuContentItem {
    isSpecial?: boolean;
    popup?: string;
    ccbKey?: string;
    isSport?: boolean;
    isFixed?: boolean;
    hasSeparator?: boolean;
}

export interface SizedNavigationItem {
    item: TopMenuContentItem;
    width: number;
}

export enum TrackNavArea {
    NavTop = 'TopNav',
    NavBottom = 'BottomNav',
    NavSub = 'SubNav',
    NavLive = 'LiveNav',
    NavVirtual = 'VirtualNav',
    NavBreadcrumb = 'Breadcrumb',
}
